<div class="media"
     [ngClass]="{
         'shaded': shadeImage(),
         'faded': hasDescription() && !shadeImage()
     }">
    @if (isFedeltaImageData(currentImage())) {
        <img class="media-object" [ngClass]="{'auto-crop': autoCropCurrentImage(), 'fadeOut': fadeOutImage()}"
             alt="" [woa-image-cache]="imageData()">
    } @else if (currentImage() !== undefined) {
        <!--suppress AngularNgOptimizedImage -->
        <img class="media-object" [ngClass]="{'auto-crop': autoCropCurrentImage(), 'fadeOut': fadeOutImage()}"
             alt="" [src]="currentImage() | url">
    }
</div>
@if (currentRestrictedOrderTypes()) {
    <div class="order-type" woa-responsive [fontScale]=".1">
        <div class="order-type-indicator">
            {{ 'woa.label.deals.order-types.' + currentRestrictedOrderTypes() | translate }}
        </div>
    </div>
}
@if (peelAction() && currentActionLabel()) {
    <div class="corner">
        <svg class="peel" height="100%" width="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M 0 100 Q 25 67 17 17 Q 67 25 100 0 Z"></path>
        </svg>
        <div class="action">
            <!-- invisible button as visible button is overlaid by corner effect -->
            <woa-button [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.HIGH"
                        [invisible]="true"
                        (mousedown)="$event.preventDefault()" (mouseup)="performAction()"
                        (mouseover)="actionMouseOver()" (mouseout)="actionMouseOut()" (mousemove)="actionMouseOver()"
                        [label]="currentActionLabel() | literal"></woa-button>
        </div>
    </div>
}
<div class="description" woa-responsive [fontScale]=".1"
     [ngClass]="{
         'shaded-image': shadeImage(),
         'top': descriptionPosition() === AppPromoTextPosition.TOP,
         'center': descriptionPosition() === AppPromoTextPosition.CENTER,
         'bottom': descriptionPosition() === AppPromoTextPosition.BOTTOM
     }"
     (mousedown)="$event.preventDefault()" (mouseup)="performAction(true)"
     (mouseover)="cardMouseOver()" (mouseleave)="cardMouseOut()" (mousemove)="cardMouseOver()">
    @if (currentTitle()) {
        <div class="description-label" [ngClass]="{'fadeOut': fadeOutTitle()}">
            <div class="description-label-title">
                {{ currentTitle() }}
            </div>
        </div>
    }
    @if (currentProductName()) {
        <div class="description-product" [ngClass]="{'fadeOut': fadeOutProductDetails()}">
            <div class="description-product-details">
                <div class="description-product-details-name">
                    {{ currentProductName() }}
                </div>
                <div class="description-product-details-price">
                    {{ currentProductPrice() | woaCurrency }}
                </div>
            </div>
        </div>
    }
    @if (currentMessage()) {
        <div class="description-message" [ngClass]="{'fadeOut': fadeOutMessage()}">
            <div class="description-message-title">
                {{ currentMessage() }}
            </div>
        </div>
    }
    @if (showCode() && deal()?.dealCode && deal()?.showAppQrCode) {
        <div class="description-code">
            <woa-qr-code-panel [value]="dealCode()" [message]="'woa.label.deals.qrCode' | translate"></woa-qr-code-panel>
        </div>
    }
    @if (inlineAction() && currentActionLabel()) {
        <div class="action" [ngClass]="{'shaded-image': shadeImage()}">
            <woa-button [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.HIGH"
                        [overrideOutlineBorderColor]="shadeImage()"
                        [overrideOutlineForegroundColor]="shadeImage()"
                        (mousedown)="$event.preventDefault()" (mouseup)="performAction()"
                        [label]="currentActionLabel() | literal"></woa-button>
        </div>
    }
</div>
@if (showCodeLink() && deal()?.dealCode && deal()?.showAppQrCode) {
    <woa-icon-button class="code-open"
                     [type]="IconButtonType.SCAN" (onActivate)="showDealQRCode()"></woa-icon-button>
}
@if (!inlineAction() && currentActionLabel()) {
    <div class="action"
         [ngClass]="{
             'shaded-image': shadeImage(),
             'fadeOut': fadeOutImage(),
             'peel': peelAction()
         }">
        <woa-button [tier]="ButtonTier.SECOND" [prominence]="peelAction() ? ButtonProminence.LOW : ButtonProminence.HIGH"
                    [overrideOutlineBorderColor]="shadeImage() && !peelAction()"
                    [overrideOutlineForegroundColor]="shadeImage() && !peelAction()"
                    [hovered]="actionHover()"
                    (mousedown)="$event.preventDefault()" (mouseup)="performAction()"
                    [label]="currentActionLabel() | literal"></woa-button>
    </div>
}
